import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useCompany } from '../context/CompanyContext';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import './Settings.css';

const TABS = ['Profile','Company','Security','Billing','Roles'];

export default function Settings() {
  const { theme }  = useTheme();
  const { user, switchRole } = useAuth();
  const { company, update } = useCompany();
  const [tab,    setTab]    = useState('Profile');
  const [co,     setCo]     = useState(company);
  const [saved,  setSaved]  = useState(false);
  const setCof = (k,v) => setCo(p=>({...p,[k]:v}));

  const save = () => { update(co); setSaved(true); setTimeout(()=>setSaved(false),2000); };

  return (
    <div className="st-wrap" data-theme={theme}>
      <Sidebar/>
      <div className="st-main">
        <Topbar title="Settings" subtitle="Manage your account and workspace"/>
        <div className="st-body">
          <div className="st-nav">
            {TABS.map(t=><div key={t} className={`st-nav-item${tab===t?' active':''}`} onClick={()=>setTab(t)}>{t}</div>)}
          </div>
          <div className="st-content">
            {tab==='Profile' && (
              <div className="st-section">
                <div className="st-sec-title">My Profile</div>
                <div className="st-av-row">
                  <div className="st-av">{user.initials}</div>
                  <div>
                    <div className="st-av-name">{user.name}</div>
                    <div className="st-av-role">{user.role}</div>
                  </div>
                </div>
                <div className="st-fields">
                  <div className="st-field-grp"><label className="st-lbl">Name</label><input className="st-inp" defaultValue={user.name}/></div>
                  <div className="st-field-grp"><label className="st-lbl">Email</label><input className="st-inp" defaultValue={user.email}/></div>
                  <div className="st-field-grp"><label className="st-lbl">Phone</label><input className="st-inp" placeholder="+91 XXXXX XXXXX"/></div>
                  <div className="st-field-grp"><label className="st-lbl">Department</label><input className="st-inp" defaultValue={user.dept}/></div>
                </div>
                <div className="st-save-row">
                  <div className="st-save-btn" onClick={save}>{saved?'✓ Saved':'Save changes'}</div>
                </div>
              </div>
            )}
            {tab==='Company' && (
              <div className="st-section">
                <div className="st-sec-title">Company Profile</div>
                <div className="st-fields">
                  {[
                    {k:'name',    label:'Company name',   placeholder:'Ryzenforge Enterprises LLP'},
                    {k:'tagline', label:'Tagline',         placeholder:'Run your business smarter'},
                    {k:'email',   label:'Business email',  placeholder:'hello@company.in'},
                    {k:'phone',   label:'Phone',           placeholder:'+91 XXXXX XXXXX'},
                    {k:'website', label:'Website',         placeholder:'www.company.in'},
                    {k:'gstin',   label:'GSTIN',           placeholder:'22AAAAA0000A1Z5'},
                    {k:'address', label:'Address',         placeholder:'Street, Building'},
                    {k:'city',    label:'City',            placeholder:'Kochi'},
                    {k:'state',   label:'State',           placeholder:'Kerala'},
                    {k:'pincode', label:'Pincode',         placeholder:'682017'},
                  ].map(f=>(
                    <div key={f.k} className="st-field-grp">
                      <label className="st-lbl">{f.label}</label>
                      <input className="st-inp" placeholder={f.placeholder} value={co[f.k]||''} onChange={e=>setCof(f.k,e.target.value)}/>
                    </div>
                  ))}
                </div>
                <div className="st-save-row">
                  <div className="st-save-btn" onClick={save}>{saved?'✓ Saved':'Save company profile'}</div>
                </div>
              </div>
            )}
            {tab==='Security' && (
              <div className="st-section">
                <div className="st-sec-title">Security</div>
                <div className="st-fields">
                  <div className="st-field-grp"><label className="st-lbl">Current password</label><input className="st-inp" type="password" placeholder="••••••••"/></div>
                  <div className="st-field-grp"><label className="st-lbl">New password</label><input className="st-inp" type="password" placeholder="••••••••"/></div>
                  <div className="st-field-grp"><label className="st-lbl">Confirm password</label><input className="st-inp" type="password" placeholder="••••••••"/></div>
                </div>
                <div className="st-save-row"><div className="st-save-btn">Update password</div></div>
                <div className="st-divider"/>
                <div className="st-sec-subtitle">Two-factor authentication</div>
                <div className="st-2fa-row">
                  <div><div className="st-2fa-title">Authenticator app</div><div className="st-2fa-sub">Use an app like Google Authenticator</div></div>
                  <div className="st-2fa-badge">Not enabled</div>
                </div>
                <div className="st-enable-btn">Enable 2FA</div>
              </div>
            )}
            {tab==='Billing' && (
              <div className="st-section">
                <div className="st-sec-title">Billing</div>
                <div className="st-billing-card">
                  <div className="st-plan-name">RyzenOS Pro</div>
                  <div className="st-plan-price">₹7,499 <span>/month</span></div>
                  <div className="st-plan-status">✓ Active — Next billing 26 June 2026</div>
                </div>
                <div className="st-billing-info">
                  {[{label:'Plan',val:'Pro — Unlimited leads, team, finance'},{label:'Users',val:'Up to 25 team members'},{label:'Storage',val:'50 GB'},{label:'Support',val:'Priority support'}].map(r=>(
                    <div key={r.label} className="st-info-row"><span className="st-info-lbl">{r.label}</span><span className="st-info-val">{r.val}</span></div>
                  ))}
                </div>
                <div className="st-save-row"><div className="st-cancel-btn">Cancel subscription</div></div>
              </div>
            )}
            {tab==='Roles' && (
              <div className="st-section">
                <div className="st-sec-title">Roles & Permissions</div>
                <div className="st-roles-info">Roles are assigned when adding team members. Role affects what each person can see and do in RyzenOS.</div>
                {[
                  {role:'Super Admin',color:'#F5A623',perms:['Full access to all modules','Add/edit/delete leads, clients, team','Manage billing and settings','View all reports and analytics']},
                  {role:'Admin',color:'#3B82F6',perms:['View all modules','Add/edit leads, clients, projects','Cannot delete team members','Cannot access billing']},
                  {role:'User',color:'#22C55E',perms:['View assigned tasks only','Mark own attendance','Request leave','View own salary']},
                ].map(r=>(
                  <div key={r.role} className="st-role-card">
                    <div className="st-role-hd"><div className="st-role-name" style={{color:r.color}}>{r.role}</div></div>
                    <ul className="st-role-perms">{r.perms.map(p=><li key={p} className="st-role-perm">{p}</li>)}</ul>
                  </div>
                ))}
                <div className="st-divider"/>
                <div className="st-sec-subtitle">Preview as role (demo)</div>
                <div className="st-role-switcher">
                  {['Super Admin','Admin','User'].map(r=>(
                    <div key={r} className={`st-role-sw-btn${user.role===r?' active':''}`} onClick={()=>switchRole(r)}>{r}</div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
